var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2597 3L13 3C13 1.34315 11.6569 0 10 0H8C6.34314 0 5 1.34315 5 3L4.34328 3L4 3L3.99882 3L1 3C0.447715 3 0 3.44772 0 4C0 4.55229 0.447715 5 1 5L2 5L2 17C2 18.6569 3.34315 20 5 20H13C14.6569 20 16 18.6569 16 17L16 5L17 5C17.5523 5 18 4.55228 18 4C18 3.44771 17.5523 3 17 3L14.0018 3L14 3L13.2597 3ZM14 5H12L11 5L7 5L6 5L4 5L4 7L4 17C4 17.5523 4.44772 18 5 18H13C13.5523 18 14 17.5523 14 17L14 7V5ZM7 3H8H9L10 3H11C11 2.44772 10.5523 2 10 2L8 2C7.44772 2 7 2.44772 7 3ZM7 7C7.55228 7 8 7.44772 8 8V15C8 15.5523 7.55228 16 7 16C6.44772 16 6 15.5523 6 15V8C6 7.44772 6.44772 7 7 7ZM12 8C12 7.44772 11.5523 7 11 7C10.4477 7 10 7.44772 10 8V15C10 15.5523 10.4477 16 11 16C11.5523 16 12 15.5523 12 15V8Z",
    fill: "#2C659B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.b7fde8a11cf8d211237226c53f928bb2.svg";
export { ForwardRef as ReactComponent };